"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadDropbox;

var _loadScript = _interopRequireDefault(require("FileManagerCore/utils/loadScript"));

var DROPBOX_SCRIPT_URL = 'https://www.dropbox.com/static/api/2/dropins.js';
var DROPBOX_KEY = '8p1hrg9mm92cd0h';

function loadDropbox() {
  return (0, _loadScript.default)(DROPBOX_SCRIPT_URL, {
    'data-app-key': DROPBOX_KEY,
    id: 'dropboxjs'
  });
}

module.exports = exports.default;